const contentful = require('contentful-management');

const client = contentful.createClient({
  accessToken: `${process.env.CONTENT_MANAGEMENT_KEY}`,
});

module.exports = client 